import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Lock, HelpCircle } from 'lucide-react';
export interface FaqItem {
  question: string;
  answer: string;
  icon?: 'lock' | 'help';
}
interface FaqAccordionProps {
  items: FaqItem[];
}
const iconFor = (icon?: 'lock' | 'help') => {
  if (icon === 'lock') return <Lock className="w-4 h-4" strokeWidth={1.5} data-id="element-277" />;
  return <HelpCircle className="w-4 h-4" strokeWidth={1.5} data-id="element-278" />;
};
export const FaqAccordion = ({
  items
}: FaqAccordionProps) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="w-full divide-y divide-gold/15" data-id="element-279">
      {items.map((item, i) => {
      const isOpen = openIndex === i;
      return <div key={i} className="py-1" data-id="element-280">
            <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full flex items-start gap-3 py-4 px-2 text-left hover:bg-gold/[0.03] transition-colors duration-200 rounded-sm" aria-expanded={isOpen} data-id="element-281">
              <span className="mt-0.5 flex-shrink-0" style={{
            color: '#D4AF37'
          }} aria-hidden="true" data-id="element-282">
                {iconFor(item.icon)}
              </span>
              <span className="flex-1 font-sans" style={{
            color: isOpen ? '#D4AF37' : '#F5F0E8',
            fontSize: '15px',
            fontWeight: 500,
            lineHeight: 1.45,
            transition: 'color 0.2s ease'
          }} data-id="element-283">
                {item.question}
              </span>
              <motion.span animate={{
            rotate: isOpen ? 180 : 0
          }} transition={{
            duration: 0.3
          }} className="flex-shrink-0 mt-0.5" style={{
            color: '#b8923d'
          }} data-id="element-284">
                <ChevronDown className="w-5 h-5" strokeWidth={1.5} data-id="element-285" />
              </motion.span>
            </button>
            <AnimatePresence initial={false} data-id="element-286">
              {isOpen && <motion.div key="content" initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-287">
                  <div className="pl-9 pr-2 pb-5" data-id="element-288">
                    <p className="font-sans" style={{
                color: '#E0D4BC',
                fontSize: '14.5px',
                lineHeight: 1.65,
                fontWeight: 400
              }} data-id="element-289">
                      {item.answer}
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
};